
<span v-if="isSuperAdmin" class="super-admin-badge-host">
  <v-tooltip v-model="tooltipOpen" bottom open-on-focus :open-delay="150">
    <template #activator="{ on, attrs }">
      <span
        class="super-admin-badge"
        :class="{ 'super-admin-badge--compact': compact }"
        v-bind="attrs"
        v-on="on"
        :tabindex="focusable ? 0 : null"
        :aria-label="description"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
          <path d="M12 3 4.5 6v5c0 4.8 3.1 8.2 7.5 10 4.4-1.8 7.5-5.2 7.5-10V6L12 3Z" />
          <path d="m8.5 12 2.3 2.3 4.7-4.6" />
        </svg>
        <span v-if="!compact">Super Admin</span>
      </span>
    </template>
    <span>{{ description }}</span>
  </v-tooltip>
</span>
